import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { createStyles } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { getUserDetails, updateUserDetails } from '../../../services/users/users.service';
import { UserM, AccountTypeEnum } from '../../../models/user.types';
import ExaminerDataForm from '../../../components/EditUser/ExaminerDataForm.comonent';
import EditUserForm from '../../../components/EditUser/EditUserForm.component';
import { AxiosResponse } from 'axios';
import { useLayoutContext } from '../../../Context/Layout.context';

const styles = () =>
  createStyles({
    root: {
      height: '586px',
      width: '768px',
      margin: 0,
      padding: 0,
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, ...other } = props;
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      {children}
    </MuiDialogTitle>
  );
});

interface ExaminerDialogProps {
  id: string;
  isUserUpdated: () => void;
  onClose: () => void;
  isEdit: boolean;
  isOpen: boolean;
}

export default function ExaminerDialog(props: ExaminerDialogProps) {
  const [user, setUser] = useState<UserM | undefined>(undefined);
  const [stage1, setStage1] = useState<boolean>(true);
  const [stage2, setStage2] = useState<boolean>(false);

  const { openAlert } = useLayoutContext();

  useEffect(() => {
    if (stage1 && props.id) {
      getUserDetails(props.id).then((result: UserM) => {
        if (result) {
          setUser(result);
        }
      });
    }
  }, [props.id, stage1]);

  const goToEdit = () => {
    setStage1(false);
    setStage2(true);
  };

  const goToDataView = () => {
    setStage1(true);
    setStage2(false);
  };

  const updateUser = (
    id: string,
    firstName: string,
    lastName: string,
    phone: string,
    phoneHidden: boolean,
    email: string,
    accountTypeId: AccountTypeEnum,
    examCommiteeId: number,
    expirationDate: string,
    pesel: string,
  ) => {
    const examCommiteeIdProps = examCommiteeId;
    let updateSuccessfull = false;
    updateUserDetails(
      id,
      firstName,
      lastName,
      phone,
      phoneHidden,
      email,
      accountTypeId,
      examCommiteeIdProps,
      expirationDate,
      pesel,
    )
      .then((result: AxiosResponse<number>) => {
        if (result.status == 200 || result.status == 204) {
          openAlert('success');
          updateSuccessfull = true;
        }
      },
        () => {
          openAlert('save_error');
        }
      )
      .then(() => {
        getUserDetails(props.id)
          .then((result: UserM) => {
            setUser(result);
            if (updateSuccessfull) props.isUserUpdated();
          })
          .then(goToDataView);
      });
  };

  useEffect(() => {
    if (props.isEdit) {
      setStage1(false);
      setStage2(true);
    }
  }, [props.isEdit]);

  const handleClose = () => {
    props.onClose();
  };

  return (
    <Dialog
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' ) {
          handleClose();
        }
      }}
      aria-labelledby="customized-dialog-title"
      open={props.isOpen}
      maxWidth={false}
    >
      {props.isOpen && (
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {stage1 && user && <ExaminerDataForm userArg={user} goToEdit={goToEdit} closeModal={handleClose} />}
          {stage2 && user && (
            <EditUserForm
              isExaminerList={true}
              userArg={user}
              goToDataView={goToDataView}
              closeModal={handleClose}
              updateUser={updateUser}
            ></EditUserForm>
          )}
        </DialogTitle>
      )}
    </Dialog>
  );
}
